<template>
  <div>
    <label class="input-label">
      {{label}}
      <select v-model="localValue">
        <option v-for="v in options" :key="v.value" :value="v.value">
          {{v.label}}
        </option>
      </select>
      <div class="input-help" v-html="help" v-if="help"></div>
    </label>
  </div>

</template>

<script>
export default {
  name: 'InputSelect',
  props: {
    value: {
      type: String
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    help: {
      type: String,
      default: ''
    }
  },
  computed: {
    localValue: {
      get () {
        return this.value ?? null;
      },
      set (v) {
        this.$emit('input', v);
      }
    }
  }
};
</script>
